/**
 * ALT Text Fallback for Static Pages
 * Finds images without ALT text and populates from nearby text content
 */
(function() {
  function findNearbyText(element) {
    // Check current element for text
    const directText = element.textContent?.trim();
    if (directText && directText.length > 2 && directText.length < 200) {
      return directText;
    }

    // Check parent elements up to 3 levels
    let parent = element.parentElement;
    let levels = 0;
    while (parent && levels < 3) {
      // Look for headings, paragraphs, spans with text
      const textElements = parent.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a');
      for (const el of textElements) {
        if (el !== element && !el.contains(element)) {
          const text = el.textContent?.trim();
          if (text && text.length > 2 && text.length < 200) {
            return text;
          }
        }
      }
      
      // Check parent's direct text content
      const parentText = Array.from(parent.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .join(' ')
        .trim();
      
      if (parentText && parentText.length > 2 && parentText.length < 200) {
        return parentText;
      }
      
      parent = parent.parentElement;
      levels++;
    }
    
    return null;
  }

  function fixAltText() {
    // Find all images without ALT or with empty ALT
    const images = document.querySelectorAll('img:not([alt]), img[alt=""]');
    
    images.forEach(img => {
      // Skip if already has meaningful alt
      if (img.alt && img.alt.trim().length > 0) return;
      
      // Try to find nearby text
      const nearbyText = findNearbyText(img);
      
      if (nearbyText) {
        // Clean up the text - remove extra whitespace, limit length
        let altText = nearbyText.replace(/\s+/g, ' ').trim();
        if (altText.length > 125) {
          altText = altText.substring(0, 122) + '...';
        }
        img.alt = altText;
      } else {
        // Default fallback
        img.alt = 'PixieLane';
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAltText);
  } else {
    fixAltText();
  }

  // Also run after a delay to catch dynamically loaded content
  setTimeout(fixAltText, 2000);
  setTimeout(fixAltText, 5000);
})();
